import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

const CountdownTimer = forwardRef((props, ref) => {

    const initialMinutes = 5;
    const initialSeconds = 0;
    const [minutes, setMinutes] = useState(initialMinutes);
    const [seconds, setSeconds] = useState(initialSeconds);

    useImperativeHandle(ref, () => ({
        resetTimer() {
            setMinutes(5);
            setSeconds(0);
        }
    }));

    useEffect(() => {
        let countdownInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                if (minutes === 0 && seconds === 0) {
                    clearInterval(countdownInterval);
                    // You can add any logic to handle what happens when the timer reaches 0 here.
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);

        return () => {
            clearInterval(countdownInterval);
        };
    }, [minutes, seconds]);

    return (
        <div>
            <span>{minutes < 10 ? `0${minutes}` : minutes}</span>:
            <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
        </div>
    );
});

export default CountdownTimer;